import React, { useEffect, useState } from "react";
import { API_BASE } from "../../../apiBase";
import { bsrLabel, hasBsr } from "../../../utils";
import ModalForHide from "./ModalForHide";
import NotDirectLinkPopup, { warningSuppliers } from "./NotDirectLinkPopup";
import { signupDiscountSuppliers } from "./RegisterForDiscount";
import { OOSbyZIPSuppliers } from "./OOSbyZIP";
import MessageBeforeLinkPopup from "./MessageBeforeLinkPopup";
import FavoritesIcon from "./FavoritesIcon";
import ModalForVariationsTable from "./ModalForVariationsTable";
import AdvancedData from "./AdvancedData";
import logo from "../../../logo2.svg";
import { useAuth0 } from "@auth0/auth0-react";
import ModalForBundlesTable from "./ModalForBundlesTable";
import { checkGatedBatch, productProfit, productRoi } from "../../../utils";
import { getAmazonConsentUrl } from "../../../utils_amazon";

export default function ProductsTable(props) {
  const [hideModalProduct, setHideModalProduct] = useState("");
  const { isAuthenticated, isLoading, getAccessTokenSilently, user } = useAuth0();
  const [linkUrl, setLinkUrl] = useState("");
  const [prep, setPrep] = useState(localStorage.getItem("costPrep") || 0);
  const [advancedDataProduct, setAdvancedDataProduct] = useState(null);
  const [showMessageObj, setShowMessageObj] = useState(null);
  const [ctrlClickTip, setCtrlClickTip] = useState("");
  const [searchModal, setSearchModal] = useState(null);
  const [saveMoney, setSaveMoney] = useState(null);
  const [resetAZSeller, setResetAZSeller] = useState(false);
  const [loginWAZ, setLoginWAZ] = useState(false);
  const [saveMoneyRates, setSaveMoneyRates] = useState({});
  const [modalForVariations, setModalForVariations] = useState(false);
  const [modalForVariationsAsin, setModalForVariationsAsin] = useState("");
  const [modalForBundles, setModalForBundles] = useState(false);
  const [modalForBundlesItem, setModalForBundlesItem] = useState({});
  const [headerStyle, setHeaderStyle] = useState({});
  const [loadGated, setLatedGated] = useState(false);
  const mainProductPage = ["big5sportinggoods", "dillards", "famousfootwear", "kohls", "dickssportinggoods", "boscovs", "jcpenney", "fivebelow", "nike", "belk", "underarmour", "crocs", "champssports", "sephora", "rei", "joann"]
  const categorySalesRankCount = { 'Climate Pledge Friendly': 1500000, 'Kindle Store': 6756566, 'Video Shorts': 127580, 'Apps & Games': 936100, 'Baby Products': 4172515, 'Digital Music': 68941656, 'Alexa Skills': 112529, 'Toys & Games': 9204843, 'Patio, Lawn & Garden': 22608266, 'Books': 102997339, 'Arts, Crafts & Sewing': 16296162, 'Software': 177161, 'Sports & Outdoors': 41416624, 'Gift Cards': 28409, 'Video Games': 1204647, 'Handmade Products': 3644844, 'Clothing, Shoes & Jewelry': 275101033, 'Office Products': 12266328, 'Grocery & Gourmet Food': 3869382, 'Tools & Home Improvement': 37997159, 'Movies & TV': 7740340, 'Musical Instruments': 2893522, 'Collectibles & Fine Art': 8802597, 'Appliances': 1565048, 'Pet Supplies': 8652837, 'Cell Phones & Accessories': 26169713, 'Baby': 4172515, 'Industrial & Scientific': 20388882, 'Everything Else': 8317014, 'CDs & Vinyl': 8366789, 'Beauty & Personal Care': 14890600, 'Home & Kitchen': 161989558, 'Electronics': 25856893, 'Automotive': 46255283, 'Magazine Subscriptions': 42578, 'Health & Household': 11049107, 'Audible Books & Originals': 743380, 'Kitchen & Dining': 37818304, "Amazon Devices": 1894, "Computers & Accessories": 14064999, "Camera & Photo Products": 4021127, "Collectible Coins": 210648, "Camera & Photo": 4021127 }

  const handleScroll = () => {
    try {
      const table = document.getElementById('tableTable');
      const tableRect = table.getBoundingClientRect();

      if (tableRect.top <= 0) {
        // The header is out of view (or at the top of the viewport)
        setHeaderStyle({
          position: 'relative',
          top: -tableRect.top + "px",
          zIndex: 9,
        });
      } else {
        setHeaderStyle({});
      }
    } catch { }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const checkGated = async (asins) => {
      if (props.sellerId) {
        setLatedGated(true);
        await checkGatedBatch(props.sellerId, asins, props.refreshToken, (data) => {
          Object.entries(data).forEach(([asin, response]) => {
            props.setGatedStatus((prevGS) => ({
              ...prevGS,
              [asin]: response,
            }));
          });
        });
        props.setIsProductsLoading(false);
        setLatedGated(false);
      }
    };

    if (!isLoading && isAuthenticated && props.data && props.data.length > 0 && props.sellerId !== "none" && props.sellerId !== "") {
      const asinsToCheck = [];
      props.data.forEach(prd => {
        const asin = prd.asin.split("/")[prd.asin.split("/").length - 1];
        if (!props.gatedStatus.hasOwnProperty(asin)) {
          asinsToCheck.push(asin);
        }
      });
      if (asinsToCheck.length > 0) {
        checkGated(asinsToCheck);
      } else {
        setLatedGated(false);
      }
    }

    if (!isLoading && isAuthenticated && props.data && props.data.length > 0 && localStorage.getItem("azlog_pop_first") !== "1" && sessionStorage.getItem("nepeto_suppress_azpopup") !== "1") {
      setLoginWAZ(true);
      localStorage.setItem("azlog_pop_first", "1");
    }
  }, [isLoading, isAuthenticated, props.data]);

  useEffect(() => {
    const getSaveMoneyRates = async () => {
      setSaveMoneyRates({})
      const accessToken = await getAccessTokenSilently();
      fetch(
        API_BASE + "/get_cashback_rates/" + saveMoney + "/", { mode: "cors", headers: { Authorization: `Bearer ${accessToken}` } }
      )
        .then((response) => response.json())
        .then((data) => {
          if (saveMoney !== null) {
            setSaveMoneyRates(data);
          }
        });
    };

    if (!isLoading && isAuthenticated && saveMoney !== null) {
      getSaveMoneyRates();
    }
  }, [getAccessTokenSilently, isLoading, isAuthenticated, saveMoney]);

  const getKeepaImage = async (image_asin) => {
    const accessToken = await getAccessTokenSilently();
    const response = await fetch(
      API_BASE + "/get_keepa_image/" + image_asin + "/",
      { mode: "cors", headers: { Authorization: `Bearer ${accessToken}` } }
    );
    const data = await response.json();
    return data.url;
  };

  const openSuppLink = (product) => {
    if (product.source_name === "b2bsportswear") {
      product.url = product.url.replace("+", "").replace("--", "-")
    }
    if (!warningSuppliers.includes(product.source_name)) {
      window.open(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    } else {
      setLinkUrl(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    }
  };

  return (
    <>
      <div className="table-container products-table-container">
        <table id="tableTable" className="table is-hoverable products-table">
          <thead style={headerStyle}>
            <tr>
              <th>Product</th>
              <th>Category</th>
              <th class="tooltip">
                <abbr
                  title="BSR"
                  style={{
                    display:
                      props.filters.hasOwnProperty("sortBy") &&
                      props.filters["sortBy"][0] === "sales_rank" &&
                      "flex",
                  }}
                  onClick={() => {
                    props.setSortASC(!props.sortASC);
                    props.setFilters((filters) => ({
                      ...filters,
                      sortBy: ["sales_rank", props.sortASC],
                    }));
                  }}
                >
                  BSR<span style={{ fontSize: "62%" }}>(?)</span>
                  {props.filters.hasOwnProperty("sortBy") &&
                    props.filters["sortBy"][0] === "sales_rank" && (
                      <i
                        className={
                          "fa fa-arrow-" +
                          (props.filters["sortBy"][1] ? "up" : "down")
                        }
                        aria-hidden="true"
                        style={{ marginTop: "5px" }}
                      ></i>
                    )}
                </abbr>
                <span class="tooltiptext">
                  Sales Rank
                </span>
              </th>
              <th>ASIN</th>
              {props.supplierType !== "retail" && (
                <th>
                  <abbr
                    title="MOQ"
                    style={{
                      display:
                        props.filters.hasOwnProperty("sortBy") &&
                        props.filters["sortBy"][0] === "moq" &&
                        "flex",
                    }}
                    onClick={() => {
                      props.setSortASC(!props.sortASC);
                      props.setFilters((filters) => ({
                        ...filters,
                        sortBy: ["moq", props.sortASC],
                      }));
                    }}
                  >
                    MOQ
                    {props.filters.hasOwnProperty("sortBy") &&
                      props.filters["sortBy"][0] === "moq" && (
                        <i
                          className={
                            "fa fa-arrow-" +
                            (props.filters["sortBy"][1] ? "up" : "down")
                          }
                          aria-hidden="true"
                          style={{ marginTop: "5px" }}
                        ></i>
                      )}
                  </abbr>
                </th>
              )}
              <th>
                <abbr
                  title="Price"
                  style={{
                    display:
                      props.filters.hasOwnProperty("sortBy") &&
                      props.filters["sortBy"][0] === "price" &&
                      "flex",
                  }}
                  onClick={() => {
                    props.setSortASC(!props.sortASC);
                    props.setFilters((filters) => ({
                      ...filters,
                      sortBy: ["price", props.sortASC],
                    }));
                  }}
                  className="tooltip"
                >
                  Price<span style={{ fontSize: "65%" }}>(?)</span>
                  <span class="tooltiptext" style={{ marginTop: "-15%" }}>
                    Cost per unit from the supplier
                  </span>
                  {props.filters.hasOwnProperty("sortBy") &&
                    props.filters["sortBy"][0] === "price" && (
                      <i
                        className={
                          "fa fa-arrow-" +
                          (props.filters["sortBy"][1] ? "up" : "down")
                        }
                        aria-hidden="true"
                        style={{ marginTop: "5px" }}
                      ></i>
                    )}
                </abbr>
              </th>
              <th class="tooltip">AZPrice<span style={{ fontSize: "65%" }}>(?)</span>
                <span class="tooltiptext" style={{ marginTop: "-15%" }}>
                  Lowest New Price *Include Shipping
                  <img style={{ all: "unset", width: "8.5vw" }} loading="lazy" alt="azprice" src="/assets/azprice.png" />
                </span></th>
              <th class="tooltip">
                AZFees<span style={{ fontSize: "62%" }}>(?)</span>
                <span class="tooltiptext">
                  Amazon Referral Fee {!(props.filters.hasOwnProperty("isFBM") && props.filters.isFBM) && "+ Fulfillment Cost (FBA)"}
                </span>
              </th>
              <th class="tooltip" style={{ fontSize: "95%" }}>
                Costs<span style={{ fontSize: "62%" }}>(?)</span>
                <span class="tooltiptext">
                  Input any additional costs, such as prep cost, FBM, and
                  others.
                </span>
              </th>
              <th>AZOffers</th>
              <th>
                <abbr
                  title="Profit"
                  style={{
                    display:
                      props.filters.hasOwnProperty("sortBy") &&
                      props.filters["sortBy"][0] === "profit" &&
                      "flex",
                  }}
                  onClick={() => {
                    props.setSortASC(!props.sortASC);
                    props.setFilters((filters) => ({
                      ...filters,
                      sortBy: ["profit", props.sortASC],
                    }));
                  }}
                >
                  Profit
                  {props.filters.hasOwnProperty("sortBy") &&
                    props.filters["sortBy"][0] === "profit" && (
                      <i
                        className={
                          "fa fa-arrow-" +
                          (props.filters["sortBy"][1] ? "up" : "down")
                        }
                        aria-hidden="true"
                        style={{ marginTop: "5px" }}
                      ></i>
                    )}
                </abbr>
              </th>
              <th>
                <abbr
                  title="ROI"
                  style={{
                    display:
                      props.filters.hasOwnProperty("sortBy") &&
                      props.filters["sortBy"][0] === "roi" &&
                      "flex",
                  }}
                  onClick={() => {
                    props.setSortASC(!props.sortASC);
                    props.setFilters((filters) => ({
                      ...filters,
                      sortBy: ["roi", props.sortASC],
                    }));
                  }}
                >
                  ROI
                  {props.filters.hasOwnProperty("sortBy") &&
                    props.filters["sortBy"][0] === "roi" && (
                      <i
                        className={
                          "fa fa-arrow-" +
                          (props.filters["sortBy"][1] ? "up" : "down")
                        }
                        aria-hidden="true"
                        style={{ marginTop: "5px" }}
                      ></i>
                    )}
                </abbr>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {props.data.length === 0 && <td style={{ textAlign: "center" }} colSpan={12}>No products. Have you tried our <a href="/live-search" style={{ fontSize: "700" }}>Live Search</a> yet?</td>}
            {props.data.map((product, index) => {
              if ((!props.filters.filterOutGated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") !== "red") &&
                (!props.filters.showOnlyUngated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") === "green")) {
                return (<>
                  <tr key={index}>
                    <td style={{ width: "22vw" }}>
                      <div style={{ display: "flex" }}>
                        <div className="amazonImage">
                          <p
                            onClick={() => {
                              window.open(product.asin + "?th=1&psc=1");
                            }}
                            style={{ textAlign: "center", cursor: "pointer" }}
                          >
                            Amazon
                          </p>
                          <img
                            alt="product_image"
                            className="hoverImageTable"
                            loading="lazy"
                            src={(product.az_img !== null && product.az_img !== "") ?
                              product.az_img :
                              `https://images.amazon.com/images/P/${product.asin.split("/")[product.asin.split("/").length - 1]}.jpg`}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = "/assets/noimage.png";
                            }}
                            style={{
                              borderRadius: "4.5vw",
                              border: "5px solid #E3D0DF",
                              height: "4.5vw",
                              width: "4.5vw",
                              objectFit: "scale-down",
                              position: "relative",
                              zIndex: "5"
                            }}
                            onMouseEnter={() => {
                              if (localStorage.getItem("CtrlClickTipCount") === null || localStorage.getItem("CtrlClickTipCount") < 15) {
                                setCtrlClickTip(product.asin);
                                localStorage.setItem("CtrlClickTipCount", localStorage.getItem("CtrlClickTipCount") === null ? 1 : parseInt(localStorage.getItem("CtrlClickTipCount")) + 1);
                              }
                            }}
                            onMouseLeave={() => setCtrlClickTip("")}
                            onClick={() => {
                              window.open(product.asin + "?th=1&psc=1");
                            }}
                          />
                        </div>
                        <i class="fa fa-external-link" title="Open the two links at the same time" aria-hidden="true" style={{ position: "absolute", marginLeft: "9vw", cursor: "pointer" }} onClick={() => {
                          let message = "";
                          if (mainProductPage.includes(product.source_name)) {
                            message +=
                              "You will see the main product page.\nYou will need to set the correct variation yourself.\n'..." + product.title.split(" | At")[0].slice((product.title.split(" | At")[0].length / 2).toFixed(0)) + "'<br/>";
                          }
                          if (
                            signupDiscountSuppliers.includes(
                              product.source_name
                            )
                          ) {
                            message +=
                              "To receive the lowest price, this supplier requires you to sign up to their website.";
                          }
                          if (
                            OOSbyZIPSuppliers.includes(
                              product.source_name
                            )
                          ) {
                            message +=
                              "\nIf the product is out of stock - Change the ZIP CODE!\n";
                          }
                          if (message !== "" && (localStorage.getItem("showSuppMesssage" + product.source_name) === 'true' || localStorage.getItem("showSuppMesssage" + product.source_name) === null)) {
                            setShowMessageObj({
                              message: message,
                              messageAction: openSuppLink,
                              messageActionArg: product,
                              source: product.source_name
                            });
                          } else {
                            openSuppLink(product);
                          }
                          let secondOpened = window.open(product.asin + "?th=1&psc=1", '_blank');
                          if (!secondOpened) {
                            alert("Please enable pop-ups in your browser to continue.")
                          }
                        }}></i>
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "10vw",
                            height: "10vh",
                            padding: "9px",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "77.5%"
                          }}
                        >
                          {product.title.split(" | At")[0].slice(0, 40)}...{product.title.split(" | At")[0].slice(-25)}
                          <span className="tooltip" style={{ position: "absolute", marginLeft: "2px" }}>
                            <i class="fa fa-info-circle" id="variationTt" aria-hidden="true" style={{ fontSize: "90%" }}></i>
                            <span className="tooltiptext" style={{ zIndex: "999", padding: "5px" }}>
                              {product.title.split(" | At")[0]}
                            </span>
                          </span>
                        </span>
                        {ctrlClickTip === product.asin && <span style={{ position: "absolute", backgroundColor: "#E3D0DF", zIndex: "999", marginLeft: "6.5vw", padding: "5px", fontSize: "70%", marginTop: "10vh" }}>
                          Tip: Hold CTRL + Click.
                        </span>}
                        <div className="sourceImage">
                          <p
                            onClick={() => {
                              let message = "";
                              if (mainProductPage.includes(product.source_name)) {
                                message +=
                                  "You will see the main product page.\nYou will need to set the correct variation yourself.\n'..." + product.title.split(" | At")[0].slice((product.title.split(" | At")[0].length / 2).toFixed(0)) + "'<br/>";
                              }
                              if (
                                signupDiscountSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "To receive the lowest price, this supplier requires you to sign up to their website.";
                              }
                              if (
                                OOSbyZIPSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "\nIf the product is out of stock - Change the ZIP CODE!\n";
                              }
                              if (message !== "" && (localStorage.getItem("showSuppMesssage" + product.source_name) === 'true' || localStorage.getItem("showSuppMesssage" + product.source_name) === null)) {
                                setShowMessageObj({
                                  message: message,
                                  messageAction: openSuppLink,
                                  messageActionArg: product,
                                  source: product.source_name
                                });
                              } else {
                                openSuppLink(product);
                              }
                            }}
                            style={{
                              textAlign: "center",
                              maxWidth: "4.5vw",
                              cursor: "pointer",
                            }}
                          >
                            {product.source_name.replace("-", "").replace("fragrancenet", "fragrancenetWS")}
                          </p>
                          <img
                            alt="product_image"
                            className="hoverImageTable"
                            loading="lazy"
                            src={product.img}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = "/assets/noimage.png";
                            }}
                            style={{
                              borderRadius: "4.5vw",
                              border: "5px solid #E3D0DF",
                              height: "4.5vw",
                              width: "4.5vw",
                              objectFit: "scale-down",
                              position: "relative",
                              zIndex: "5"
                            }}
                            onMouseEnter={() => {
                              if (localStorage.getItem("CtrlClickTipCount") === null || localStorage.getItem("CtrlClickTipCount") < 15) {
                                setCtrlClickTip(product.asin);
                                localStorage.setItem("CtrlClickTipCount", localStorage.getItem("CtrlClickTipCount") === null ? 1 : parseInt(localStorage.getItem("CtrlClickTipCount")) + 1);
                              }
                            }}
                            onMouseLeave={() => setCtrlClickTip("")}
                            onClick={() => {
                              let message = "";
                              if (mainProductPage.includes(product.source_name)) {
                                message +=
                                  "You will see the main product page.\nYou will need to set the correct variation yourself.\n'..." + product.title.split(" | At")[0].slice((product.title.split(" | At")[0].length / 2).toFixed(0)) + "'<br/>";
                              }
                              if (
                                signupDiscountSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "To receive the lowest price, this supplier requires you to sign up to their website.";
                              }
                              if (
                                OOSbyZIPSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "\nIf the product is out of stock - Change the ZIP CODE!\n";
                              }
                              if (message !== "" && (localStorage.getItem("showSuppMesssage" + product.source_name) === 'true' || localStorage.getItem("showSuppMesssage" + product.source_name) === null)) {
                                setShowMessageObj({
                                  message: message,
                                  messageAction: openSuppLink,
                                  messageActionArg: product,
                                  source: product.source_name
                                });
                              } else {
                                openSuppLink(product);
                              }
                            }}
                          />
                          {(product.source_name === "boscovs" || product.source_name === "dickssportinggoods" || product.source_name === "b2bsportswear" || product.source_name === "rei" || product.source_name === "joann") &&
                            <div className="warningSign" style={{ borderBottom: "2px solid rgba(0,155,0,0.5)" }}>
                              <i class="fa fa-info-circle" aria-hidden="true"></i>
                              <span className="warText"> Select the correct variation on {product.source_name}'s website.</span>
                            </div>}
                        </div>
                        {product.title.includes("Last Update") && (
                          <span
                            style={{
                              fontSize: "0.7vw",
                              position: "absolute",
                              marginTop: "5.75%",
                              marginLeft: "-1%",
                              opacity: "0.7",
                              height: "0px",
                            }}
                            id="foundOnText"
                          >
                            Found on{" "}
                            {new Date(product.title.split("Last Update: ")[1])
                              .toLocaleString()
                              .includes("Invalid")
                              ? product.title.split("Last Update: ")[1]
                              : new Date(
                                product.title.split("Last Update: ")[1]
                              ).toLocaleString()}
                            {product.qty === -1 && <span style={{ color: "red" }}> - Out Of Stock Online</span>}
                            {(product.qty === 0 || product.source_name === "acehardware") && <>{" "}<i class="fa fa-exclamation-triangle tooltip" aria-hidden="true" style={{ color: "red" }}>
                              <span className="tooltiptext" style={{ padding: "5%", fontSize: "105%", fontFamily: "sans-serif", marginTop: "12%", width: "176%", marginLeft: "-88%" }}>
                                We were unable to verify the stock level.
                              </span>
                            </i></>}
                            {(product.source_name === "kmart") && <>{" "}<i class="fa fa-exclamation-circle tooltip" aria-hidden="true" style={{ color: "red" }}>
                              <span className="tooltiptext" style={{ padding: "5%", fontSize: "105%", fontFamily: "sans-serif", marginTop: "12%", width: "176%", marginLeft: "-88%" }}>
                                Be aware of 3P Sellers!
                              </span>
                            </i></>}
                          </span>
                        )}
                        <span
                          style={{
                            fontSize: "0.7vw",
                            position: "absolute",
                            marginTop: "5.8%",
                            marginLeft: props.supplierType !== "retail" ? "83.5%" : "82.5%",
                            height: "0px",
                            textDecoration: "underline",
                            textDecorationColor: "rgba(139,60,160,0.5)",
                            cursor: "pointer"
                          }}
                          className="tooltip"
                          id="notInterested"
                          onClick={() => {
                            if (window.confirm("Are you sure you don't want to see this ASIN again for 30 days?")) {
                              props.setData((prevList) => prevList.filter((_, subIndex) => subIndex !== index))
                              localStorage.setItem(product.asin.split("/")[product.asin.split("/").length - 1] + "NIU", Date.now() + 30 * 24 * 60 * 60 * 1000)
                            }
                          }}
                        >
                          Not Interested<span style={{ fontSize: "80%" }}>(?)</span>
                          <span
                            class="tooltiptext"
                            style={{
                              marginTop: "24%",
                              zIndex: "2000",
                              padding: "3px 6px",
                              border: "1px solid black"
                            }}
                          >
                            Don't see it again for 30 days
                          </span>
                        </span>
                      </div>
                    </td>
                    <td id="categoryTt" style={{ color: !categorySalesRankCount[product.category] && "darkred" }}>{product.category}</td>
                    <td id="bsrTt" style={{ minWidth: "5.6vw", color: !categorySalesRankCount[product.category] && "darkred" }}>
                      <br />
                      {bsrLabel(product.sales_rank)}{hasBsr(product.sales_rank) && categorySalesRankCount[product.category] ? <><br /><span style={{ fontSize: "83%" }}>Top {((product.sales_rank / categorySalesRankCount[product.category]) * 100) < 0.01 ? "<0.01" : ((product.sales_rank / categorySalesRankCount[product.category]) * 100).toFixed(((product.sales_rank / categorySalesRankCount[product.category]) * 100) < 0.1 ? 2 : 1)}%</span></> : <span style={{ fontSize: "70%" }}><br />Sub Category</span>}
                      <br />
                      <img
                        loading="lazy"
                        src={`https://corsproxy.io/?https://graph.keepa.com/?asin=${product.asin.split("/")[
                          product.asin.split("/").length - 1
                        ]}&domain=com&salesrank=1&amazon=1&new=1&bb=1&fba=1&range=90`}
                        onMouseEnter={async (e) => {
                          if (e.target.alt !== "keepahistloaded") {
                            e.target.src = "data:image/svg+xml;base64," + btoa('<svg width="100" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#f5f5f5"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="12" fill="#666">Loading...</text></svg>');
                            const new_url = await getKeepaImage(product.asin.split("/")[product.asin.split("/").length - 1])
                            e.target.src = new_url
                            e.target.alt = "keepahistloaded"
                          }
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            'data:image/svg+xml;base64,' +
                            btoa('<svg width="100" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#f5f5f5"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="12" fill="#666">Hover to reveal...</text></svg>');
                        }}
                        alt="keepahist"
                        style={{ position: "relative", border: "1px solid gray" }}
                        className="keepagraphprd"
                        onClick={() =>
                          window.open(
                            `https://keepa.com/#!product/1-${product.asin.split("/")[
                            product.asin.split("/").length - 1
                            ]}`,
                            "_blank"
                          )
                        }
                      />
                    </td>
                    <td id="asinTt">
                      <br />
                      <a
                        href={product.asin}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: "underline", color: "#8B3C7E" }}
                      >
                        {
                          product.asin.split("/")[
                          product.asin.split("/").length - 1
                          ]
                        }
                      </a><br />
                      <i class="fa fa-clone tooltip" aria-hidden="true"
                        onClick={(e) => {
                          navigator.clipboard.writeText(product.asin.split("/")[
                            product.asin.split("/").length - 1
                          ]);
                          e.target.className += " beat-animation"
                        }}
                        style={{ cursor: "copy", marginTop: "-.6%", fontSize: "75%" }}
                      ></i>&nbsp;
                      <button
                        className="graphicon"
                        id="variationBtnTt"
                        style={{
                          width: "calc(1.1vh + 4.45vw)",
                          height: "calc(1.2vh + .75vw)",
                          borderRadius: "20px",
                          border: "2px solid gray",
                          objectFit: "contain",
                          fontSize: ".65vw",
                          cursor: "pointer",
                          color: "rgb(139, 60, 126)",
                          fontWeight: "600",
                          marginBottom: "7px",
                          backgroundColor: "white",
                        }}
                        onClick={() => {
                          setModalForVariationsAsin(product.asin.split("/")[product.asin.split("/").length - 1]);
                          setModalForVariations(true)
                        }}
                      >VARIATIONS</button>
                      <button
                        className="graphicon"
                        id="bundlesBtnTt"
                        style={{
                          width: "calc(1.1vh + 4.45vw)",
                          height: "calc(1.2vh + .75vw)",
                          borderRadius: "20px",
                          border: "2px solid gray",
                          objectFit: "contain",
                          fontSize: ".65vw",
                          cursor: "pointer",
                          color: "rgb(139, 60, 126)",
                          fontWeight: "600",
                          marginBottom: "7px",
                          backgroundColor: "white",
                        }}
                        onClick={() => {
                          setModalForBundlesItem(product);
                          setModalForBundles(true)
                        }}
                      >MULTIPACKS</button>
                    </td>
                    {props.supplierType !== "retail" && (
                      <td style={{ verticalAlign: (product.source_minimum_order && parseFloat(product.source_minimum_order) > 0) ? "bottom" : "middle" }}>x{product.moq}<br />{(product.source_minimum_order && parseFloat(product.source_minimum_order) > 0) ? <span style={{ fontSize: "70%", color: "darkred" }} class="tooltip">${product.source_minimum_order}<br /><span class="tooltiptext" style={{ position: "relative", left: "112%" }}>Min. Order</span></span> : ""}</td>
                    )}
                    <td id="buyPriceTt" style={{ width: "4.5vw", maxWidth: "4.5vw", paddingTop: props.supplierType === "retail" ? ((localStorage.getItem("salesTax") ? parseFloat(localStorage.getItem("salesTax")) : 0) > 0 ? "3%" : "1.6%") : "0%", paddingBottom: "0px" }} class="bg">
                      ${(product.price * (1 - (props.filters.hasOwnProperty("priceCoupon") && (props.filters["priceCoupon"] / 100)))).toFixed(2)}
                      <br />
                      {(localStorage.getItem("salesTax") ? parseFloat(localStorage.getItem("salesTax")) : 0) > 0 && <span style={{ fontSize: "75%", position: "absolute", marginLeft: "-1.5%", marginTop: "-0.2%" }} className="tooltip">
                        +${(product.price * ((localStorage.getItem("salesTax") ? parseFloat(localStorage.getItem("salesTax")) : 0) / 100)).toFixed(2)}
                        {" "}<i class="fa fa-info-circle" id="variationTt" aria-hidden="true" style={{ fontSize: "90%" }}></i>
                        <span className="tooltiptext" style={{ fontSize: "120%" }}>{(localStorage.getItem("salesTax") ? parseFloat(localStorage.getItem("salesTax")) : 0)}% Sales Tax</span>
                      </span>}
                      {(localStorage.getItem("salesTax") ? parseFloat(localStorage.getItem("salesTax")) : 0) > 0 && <br />}
                      {props.supplierType === "retail" && <button
                        className="graphicon"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "20px",
                          border: "2px solid gray",
                          objectFit: "contain",
                          fontSize: "65%",
                          cursor: "pointer",
                          color: "rgb(139, 60, 126)",
                          fontWeight: "600",
                          backgroundColor: "white",
                        }}
                        onClick={() => {
                          setSaveMoney(product.source_name)
                        }}
                      >Save $</button>}
                    </td>
                    <td id="sellPriceTt" style={{ width: "6.5vw", maxWidth: "6.5vw" }} class="bg">
                      ${product.az_price.toFixed(2)}
                    </td>
                    <td id="azFeesTt">
                      {product.selling_on_az_fees === 0 || product.fba_cost === 0
                        ? "N/A"
                        : "-$" +
                        (product.selling_on_az_fees + (!props.filters.isFBM && product.fba_cost)).toFixed(
                          2
                        )}
                      <i class="fa fa-question tooltip" aria-hidden="true" style={{ position: "absolute", fontSize: "70%" }}>
                        <span className="tooltiptext" style={{ fontSize: "150%", fontFamily: "sans-serif", padding: "100%" }}>
                          ${product.selling_on_az_fees.toFixed(2)} Amazon Referral Fee{!props.filters.isFBM ? <><br />+<br />${(!props.filters.isFBM ? product.fba_cost : 0.00).toFixed(2)} Fulfillment Cost (FBA)</> : "."}
                        </span>
                      </i>
                    </td>
                    <td id="costTt">
                      <input
                        type="number"
                        style={{ width: "3vw" }}
                        value={prep}
                        min={0}
                        step={0.25}
                        onChange={(e) => { setPrep(e.target.value); localStorage.setItem("costPrep", e.target.value) }}
                        onBlur={(e) => e.target.value === "" && setPrep(0)}
                      />
                    </td>
                    <td id="azOffersTt">
                      {JSON.parse(product.az_offers).length}
                      {JSON.parse(product.az_offers).length === 20 && "+"}{" "}
                      <i className="fa fa-user" aria-hidden="true"></i><br />
                      <span style={{ fontSize: "80%" }}>{`FBA: ${JSON.parse(product.az_offers).filter(item => item.is_fba).length}`}<br />
                        {`FBM: ${JSON.parse(product.az_offers).filter(item => !item.is_fba).length}`}</span>
                    </td>
                    <td>
                      +$
                      {productProfit(product, props.filters, prep).toFixed(2)}
                    </td>
                    <td class="bg" id="roiTt">
                      {(productRoi(product, props.filters, prep) * 100).toFixed(2)}
                      %
                    </td>
                    <td style={{ width: "15vw" }}>
                      <div
                        className="columns is-centered"
                        style={{ display: "flex" }}
                      >
                        <button
                          className={"button is-rounded" + (!localStorage.getItem("clickedActions") ? " hidebtnglow" : "")}
                          id="hideTt"
                          style={{
                            backgroundColor: "#8B3C7E",
                            color: "white",
                            fontWeight: "700",
                            border: "#8B3C7E",
                            fontSize: ".64vw",
                          }}
                          onClick={() => {
                            setHideModalProduct(product);
                          }}
                        >
                          HIDE FROM OTHERS
                        </button>
                        <FavoritesIcon oos={false} url={product.url} favorite={product.favorite} />
                      </div>
                      <div
                        className={"columns is-centered" + (!localStorage.getItem("clickedActions") ? " actions" : "")}
                        style={{ display: "flex", marginTop: "1px" }}
                        onClick={() => localStorage.setItem("clickedActions", true)}
                      >
                        <i class="fa fa-search graphicon tooltip" style={{
                          width: "2.25vw",
                          marginTop: "1px",
                          marginLeft: "3px",
                          height: "2.25vw",
                          borderRadius: "20px",
                          border: "2px solid gray",
                          padding: "0.35vw 0vw",
                          cursor: "pointer",
                          fontSize: "1.35vw",
                        }} aria-hidden="true"
                          onClick={() => setSearchModal(product)}
                          id="searchTt"
                        ><span
                          class="tooltiptext"
                          style={{
                            marginTop: "-25%",
                            fontSize: ".75vw",
                            zIndex: "2000",
                            padding: "3px 6px",
                            border: "1px solid black",
                            fontFamily: "sans-serif",
                          }}
                        >
                            Check in other suppliers
                          </span></i>
                        <i
                          className={`fa ${(loadGated && !props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1])) ? "fa-spinner fa-spin" : (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "fa-unlock" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "fa-unlock-alt" : "fa-lock")) : "fa-unlock-alt")} graphicon tooltip`}
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: (loadGated && !props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1])) ? "0.15vw" : "0.3vw 0.2vw",
                            cursor: "pointer",
                            fontSize: "1.6vw",
                            color: props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? "white" : "rgb(195, 65, 2)",
                            backgroundColor: props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white"
                          }}
                          id="gatedTt"
                          onContextMenu={(event) => {
                            event.preventDefault(); // Prevents the default browser context menu
                            if (props.sellerId === "none" || props.sellerId === "") {
                              setLoginWAZ(true);
                            }
                            window.open("https://sellercentral.amazon.com/hz/approvalrequest/restrictions/approve?asin=" +
                              product.asin.split("/")[
                              product.asin.split("/").length - 1
                              ],
                              "_blank").focus()
                          }}
                          onClick={() => {
                            if (props.sellerId === "none" || props.sellerId === "") {
                              setLoginWAZ(true);
                            }
                            window
                              .open(
                                "https://sellercentral.amazon.com/hz/approvalrequest/restrictions/approve?asin=" +
                                product.asin.split("/")[
                                product.asin.split("/").length - 1
                                ],
                                "_blank"
                              )
                              .focus()
                          }}
                          aria-hidden="true"
                        >
                          <span
                            class="tooltiptext"
                            style={{
                              zIndex: "2000",
                              fontFamily: "sans-serif",
                              marginTop: "-25%",
                              fontSize: ".75vw",
                            }}
                          >
                            Check if Gated
                          </span>
                        </i>
                        <img
                          className="graphicon"
                          alt="keepa"
                          id="keepaTt"
                          onClick={() =>
                            window.open(
                              `https://keepa.com/#!product/1-${product.asin.split("/")[
                              product.asin.split("/").length - 1
                              ]
                              }}`,
                              "_blank"
                            )
                          }
                          src={"/assets/keepa.png"}
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: "3px",
                          }}
                        />
                        <i
                          className="fa fa-exclamation-triangle graphicon tooltip"
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: "0.4vw 0.2vw",
                            cursor: "pointer",
                            fontSize: "1.3vw",
                            color: "darkred",
                          }}
                          id="reportTt"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Report a mismatch?\nNote: Users who find 50 mismatches/out of stock will receive a free subscription!\n\nThe report will be sent to our team for verification. After confirming the mismatch, it will be counted."
                              )
                            ) {
                              props.reportMismatch(
                                product.asin.split("/")[
                                product.asin.split("/").length - 1
                                ]
                              );
                              localStorage.setItem(product.asin.split("/")[product.asin.split("/").length - 1] + "NIU", Date.now() + 30 * 24 * 60 * 60 * 1000);
                            }
                          }}
                          aria-hidden="true"
                        >
                          {" "}
                          <span
                            class="tooltiptext"
                            style={{
                              zIndex: "2000",
                              fontFamily: "sans-serif",
                              marginTop: "-25%",
                              fontSize: ".75vw",
                            }}
                          >
                            Report a mismatch / out of stock product
                          </span>
                        </i>
                      </div>
                    </td>
                  </tr>
                  {props.showAdv && <tr>
                    <td colspan={props.supplierType === "retail" ? "12" : "13"} style={{ borderColor: "#E3D0DF" }}>
                      <AdvancedData
                        isItTheProduct={advancedDataProduct === product}
                        advancedDataProduct={advancedDataProduct}
                        setProduct={() => setAdvancedDataProduct(product)}
                        closeAdvancedData={() => setAdvancedDataProduct(null)}
                        isMobile={props.isMobile}
                        setShowAdv={props.setShowAdv} />
                    </td></tr>}
                </>
                );
              }
            })}
            {(props.filters.filterOutGated || props.filters.showOnlyUngated) && (!props.data.map((d) => d.asin.split("/")[d.asin.split("/").length - 1]).every((a) => props.gatedStatus.hasOwnProperty(a)) && <tr><td colSpan={12} style={{ border: "none" }}>Checking your eligibility to sell (checking if you are gated)...{(props.sellerId === "none" || props.sellerId === "") && <button style={{ marginLeft: "15px", backgroundColor: "orange", border: "2px solid gray", borderRadius: "30px", cursor: "pointer", boxShadow: "0px 0px 5px 0px black" }} onClick={() => { localStorage.removeItem("no_azlog_popup"); setLoginWAZ(true) }}>Please click here to link your Amazon account.</button>}<progress className="progress" style={{ width: "100%", margin: "auto" }} /></td></tr>)}
            {(props.filters.filterOutGated || props.filters.showOnlyUngated) && props.data.length > 0 && (props.data.map((d) => d.asin.split("/")[d.asin.split("/").length - 1]).every((a) => props.gatedStatus.hasOwnProperty(a)) && props.data.filter((product) => {
              if ((!props.filters.filterOutGated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") !== "red") &&
                (!props.filters.showOnlyUngated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") === "green")) {
                return true
              }
            }).length === 0 && <tr><td colSpan={12} style={{ border: "none" }}>No products for which you are <strong style={{ color: "purple" }}>ungated</strong> were found on this page. Please go to the <strong style={{ color: "purple" }}>next page</strong> or set the 'Gated' filter to 'Filter out Gated ASINs' only.</td></tr>)}
          </tbody>
        </table>

        <div
          style={{
            width: "70vw",
            margin: "auto",
            height: "10vh",
            textAlign: "center",
          }}
        >
          <button
            className="button"
            style={{
              float: "left",
              width: "10vw",
              fontSize: "1.1vw",
              backgroundColor: "#8B3C7E",
              color: "white",
            }}
            onClick={() => {
              props.setPage((page) => (page > 1 ? page - 1 : 1));
              window.scrollTo(0, 0);
            }}
          >
            Previous Page
          </button>
          {props.silentjim ? <span>Page <input placeholder={props.page} type="number" onBlur={(e) => props.setPage(e.target.value)} style={{ width: "50px" }} /><span style={{ backgroundColor: "green", borderRadius: "30px", color: "white", padding: "0px 5px", cursor: "pointer" }}>✔</span></span> : <span>Page {props.page}</span>}
          <button
            id="nextPageBtn"
            className="button"
            style={{
              float: "right",
              width: "10vw",
              fontSize: "1.1vw",
              backgroundColor: "#8B3C7E",
              color: "white",
            }}
            onClick={() => {
              if (props.page > 99) {
                alert("You can view up to 100 pages. Please try a new search :)")
              } else {
                props.setPage((page) => page + 1);
                window.scrollTo(0, 0);
              }
            }}
          >
            Next page
          </button>
        </div>
      </div>
      {hideModalProduct !== "" && (
        <ModalForHide
          isMobile={props.isMobile}
          setHideModalProduct={setHideModalProduct}
          hideModalProduct={hideModalProduct}
          hideCredits={props.hideCredits}
        />
      )}
      {linkUrl !== "" && (
        <NotDirectLinkPopup
          isMobile={props.isMobile}
          setLinkUrl={setLinkUrl}
          linkUrl={linkUrl}
        />
      )}
      {showMessageObj !== null && (
        <MessageBeforeLinkPopup
          showMessageObj={showMessageObj}
          setShowMessageObj={setShowMessageObj}
        />
      )}
      {modalForVariations && (
        <ModalForVariationsTable
          variations={-999} // Custom flag to fetch variations
          currAsin={modalForVariationsAsin}
          modalForVariations={modalForVariations}
          setModalForVariations={setModalForVariations}
          isMobile={props.isMobile} />
      )}
      {modalForBundles && (
        <ModalForBundlesTable
          currItem={modalForBundlesItem}
          modalForBundles={modalForBundles}
          setModalForBundles={setModalForBundles}
          isMobile={props.isMobile}
          sellerId={props.sellerId}
          refreshToken={props.refreshToken}
          hideCredits={props.hideCredits}
          gatedStatus={props.gatedStatus}
          setGatedStatus={props.setGatedStatus}
        />
      )}
      {searchModal !== null && (
        <div
          id="modal-js-example"
          className={
            "modal" + (searchModal !== null ? " is-active" : "")
          }
        >
          <div className="modal-background" onClick={() => {
            setSearchModal(null);
          }}></div>
          <div
            className="modal-content"
            style={{ width: props.isMobile ? "90vw" : "38vw" }}
          >
            <div className="box" style={{ textAlign: "center" }}>
              <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
                Check in other suppliers
              </p>
              <p>
                A specific ASIN can be found from multiple suppliers in Nepeto. By clicking the Nepeto button, you can compare all prices from different suppliers.
              </p>
              <br />
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open(searchModal.upc !== null ?
                    `https://www.ebay.com/sch/i.html?&_nkw=${searchModal.upc}&_odkw=${searchModal.upc}` :
                    `https://www.ebay.com/sch/i.html?&_nkw=${searchModal.title.split(" | At")[0].slice(0, 40)}&_odkw=${searchModal.title.split(" | At")[0].slice(0, 40)}`,
                    "_blank"
                  )
                }
                src={"/assets/ebay.png"}
                style={{
                  width: "5vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.7vw",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />&emsp;&emsp;&emsp;
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open(window.location.href.split("?")[0] + "?asin=" + searchModal.asin.split("/")[searchModal.asin.split("/").length - 1
                  ])}
                src={logo}
                style={{
                  width: "5vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "3px",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />&emsp;&emsp;&emsp;
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open("https://www.google.com/search?q=" + searchModal.title.split(" | At")[0])}
                src={"https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/250px-Google_2015_logo.svg.png"}
                style={{
                  width: "5vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.5vw",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />
              <br /><br /><br />
              <div className="columns is-mobile is-centered">
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setSearchModal(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>)}
      {loginWAZ && localStorage.getItem("no_azlog_popup") !== "1" && (
        <div
          id="modal-js-example"
          className={
            "modal" + (loginWAZ !== null ? " is-active" : "")
          }
        >
          <div className="modal-background"></div>
          <div
            className="modal-content"
            style={{ width: props.isMobile ? "90vw" : "38vw" }}
          >
            <div className="box" style={{ textAlign: "center", fontWeight: "600" }}>
              <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
                Log in to your Amazon account to automate the eligibility check!
              </p>
              <br />
              <i
                className="fa fa-unlock graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "green"
                }} />&emsp;GREEN - You CAN sell this item!
              <br /><br />
              <i
                className="fa fa-lock graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "red"
                }} />&emsp;RED - You CANNOT sell this item!
              <br /><br />
              <i
                className="fa fa-unlock-alt graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "orange"
                }} />&emsp;ORANGE - You need to APPLY to sell this item!
              <br /><br /><br />
              <i class="fa fa-arrow-right" aria-hidden="true" style={{ fontSize: "25px", marginRight: "10px" }}></i>
              {user && user.email && <img src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png" onClick={() => window.open(getAmazonConsentUrl(user.email))} style={{ resizeMode: 'center', cursor: "pointer", boxShadow: "0px 0px 5px 0px gray", borderRadius: "5px", marginBottom: "-8px" }} />}
              <i class="fa fa-arrow-left" aria-hidden="true" style={{ fontSize: "25px", marginLeft: "10px" }}></i>
              <br /><br /><br />
              <div className="columns is-mobile is-centered" style={{ marginBottom: "1%", marginTop: '1%' }}>
                <button
                  className="button is-rounded is-danger is-outlined"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setLoginWAZ(false);
                    localStorage.setItem("no_azlog_popup", "1")
                  }}
                >
                  Do not show this message again
                </button>&emsp;
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setLoginWAZ(false);
                  }}
                >
                  Close for Now
                </button>
              </div>
            </div>
          </div>
        </div>)}
      {saveMoney !== null && (
        <div
          id="modal-js-example"
          className={
            "modal" + (saveMoney !== null ? " is-active" : "")
          }
        >
          <div className="modal-background" onClick={() => {
            setSaveMoney(null);
            setSaveMoneyRates({});
          }}></div>
          <div
            className="modal-content"
            style={{ width: props.isMobile ? "90vw" : "38vw" }}
          >
            <div className="box" style={{ textAlign: "center" }}>
              <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
                Save Money on <strong>{saveMoney.charAt(0).toUpperCase() + saveMoney.slice(1)}</strong>!
              </p>
              <p>
                Save money using cashback or a gift card from one of these websites!
                <br />
                <span style={{ fontSize: "95%" }}>After you find your desired discount, please apply it in More&gt;Coupon filter to include it in the calculations and find more profitable products.</span>
                <br /><span style={{ fontSize: "85%" }}>*Note that it will search again, so save the ASIN before applying and search for it afterward.</span>
                <br />
              </p>
              <br />
              <img
                className="graphicon"
                alt="gcwiki"
                onClick={() =>
                  window.open("https://www.giftcardwiki.com/gift-cards/" + (saveMoney.charAt(0).toUpperCase() + saveMoney.slice(1)), "_blank")
                }
                src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOV3EZSZpGuhYiChjIYalZ5ma5QYQlG22RTAqKUuQn5A&s"}
                style={{
                  width: "5vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.7vw",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />
              {!saveMoneyRates.hasOwnProperty("cardbear") ?
                <span style={{ marginLeft: "2vw", position: "absolute", marginTop: "3.6vw", fontSize: "0.75vw", textAlign: "center", width: "5vw" }}>Loading...</span> :
                <span style={{ marginLeft: "2vw", position: "absolute", marginTop: "3.6vw", fontSize: "0.7vw", color: saveMoneyRates['cardbear'] === -1 ? "red" : "green", textAlign: "center", width: "5vw" }}>{saveMoneyRates['cardbear'] === -1 ? "" : "Earn up to " + saveMoneyRates['cardbear'].toFixed(1) + "%"}</span>}
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open("https://www.cardbear.com/", "_blank")
                }
                src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLVFyxOrlEiIO-lo5ty1xtrxX2mBoNR3rt7Q&s"}
                style={{
                  marginLeft: "2vw",
                  width: "5vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.1vw",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />
              {!saveMoneyRates.hasOwnProperty("arbcard") ?
                <span style={{ marginLeft: "2vw", position: "absolute", marginTop: "3.6vw", fontSize: "0.75vw", textAlign: "center", width: "5vw" }}>Loading...</span> :
                <span style={{ marginLeft: "2vw", position: "absolute", marginTop: "3.6vw", fontSize: "0.7vw", color: saveMoneyRates['arbcard'] === -1 ? "red" : "green", textAlign: "center", width: "5vw" }}>{saveMoneyRates['arbcard'] === -1 ? "" : "Earn up to " + saveMoneyRates['arbcard'].toFixed(1) + "%"}</span>}
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open("https://arbitragecard.com/giftcards/?utm_source=nepeto", "_blank")
                }
                src={"https://arbitragecard.com/wp-content/uploads/2022/07/LOGO.svg"}
                style={{
                  width: "5vw",
                  marginLeft: "2vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.7vw",
                  objectFit: "contain",
                  cursor: "pointer",
                  backgroundColor: "black",
                }}
              />
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open(`https://www.rakuten.com/r/IG01PR?eeid=28187`, "_blank")
                }
                src={"https://static.rakuten.com/static/svg/rakuten/rak-logo-brand-v1.svg"}
                style={{
                  width: "5vw",
                  marginLeft: "2vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "3px",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />
              <img
                className="graphicon"
                alt="ebay"
                onClick={() =>
                  window.open(`https://www.befrugal.com/rs/KNCETGG/`, "_blank")
                }
                src={"https://icdn.bfrl.us/headerfooterimages/logo.png"}
                style={{
                  width: "5vw",
                  marginLeft: "2vw",
                  marginTop: "10px",
                  height: "3vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.5vw",
                  objectFit: "contain",
                  cursor: "pointer"
                }}
              />
              <br /><br /><br /><br />
              <div className="columns is-mobile is-centered">
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setSaveMoney(null);
                    setSaveMoneyRates({});
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>)}
      {resetAZSeller && localStorage.getItem("resetAZSeller") !== "no" && (
        <div
          id="modal-js-example"
          className={
            "modal" + (resetAZSeller ? " is-active" : "")
          }
        >
          <div className="modal-background" onClick={() => {
            setResetAZSeller(false)
          }}></div>
          <div
            className="modal-content"
            style={{ width: props.isMobile ? "90vw" : "38vw" }}
          >
            <div className="box" style={{ textAlign: "center" }}>
              <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
                Having trouble viewing your gated status?
              </p>
              <br /><br />
              <button
                className="button is-rounded is-success"
                style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw", boxShadow: "0px 5px 5px 0px gray" }}
                onClick={async () => {
                  await fetch(`${API_BASE}/mobile_app_remove_amz_login/`, {
                    mode: "cors",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      email: user.email,
                    })
                  })
                  window.location.reload();
                }}
              >
                Click here to try resetting and logging in again
              </button><br /><br /><br />
              <div className="columns is-mobile is-centered">
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.6vh" : ".8vw" }}
                  onClick={() => {
                    setResetAZSeller(false)
                  }}
                >
                  Close
                </button>&emsp;
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.6vh" : ".8vw" }}
                  onClick={() => {
                    setResetAZSeller(false);
                    localStorage.setItem("resetAZSeller", "no");
                  }}
                >
                  Don't show this message again
                </button><br /><br /><br />
              </div>
            </div>
          </div>
        </div>)}
    </>
  );
}
